// Dependencias
import Phaser from "phaser";
import { cargaAssetsPrincipal } from "./cargaAssets/cargaAssetsPrincipal";
import { ROUTES } from "../../../../const/routes";

class PantallaCarga extends Phaser.Scene {
  constructor() {
    super({ key: "PantallaCarga" });
  }

  preload() {
    this.cameras.main.setBackgroundColor("#000000");

    // Cargar el spritesheet para la animación de carga
    this.load.spritesheet(
      "pantallaCarga1",
      ROUTES.rutaRuletaPantallaCarga + "/pantallaCargaJuegos1Resized-Sheet.png",
      {
        frameWidth: 225,
        frameHeight: 30,
      }
    );

    // Crear la animación justo después de cargar el spritesheet
    this.load.on('filecomplete-spritesheet-pantallaCarga1', () => {
      this.anims.create({
        key: "pantallaCargando1",
        frames: this.anims.generateFrameNumbers("pantallaCarga1", { start: 0, end: 2 }),
        frameRate: 5,
        repeat: -1,
      });

      // Agregar el sprite animado en el centro de la pantalla y reproducir la animación
      const cargandoSprite = this.add.sprite(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2,
        "pantallaCarga1"
      );
      cargandoSprite.play("pantallaCargando1");
    });

    // Llama a la función de carga de assets principal
    cargaAssetsPrincipal(this);

    // Cuando la carga esté completa, iniciar la escena principal del juego
    this.load.on("complete", () => {
      this.scene.start("JuegoRuleta");
    });
  }
}

export default PantallaCarga;
